module.exports = __webpack_public_path__ + "img/tips.0afce7d8.png";